<template>
  <div class="view-job-details">
    <Container width="medium" spacing="small">
      <header class="pt-20 pt-sm-50">
        <MediaItem
          :src="job.company.logoImage.thumbnailSizeUrl"
          image-size="big"
          :router-link="!isCareersPage ? '/startups/' + job.company.key : null"
        >
          <div class="ml-4 ml-lg-20">
            <h2 class="view-job-details__title">{{ job.title }}</h2>
            <BulletInlineList class="text-gray-700">
              <template v-if="!isCareersPage">
                <router-link
                  v-if="job.company.name"
                  :to="{
                    path: '/startups/' + job.company.key
                  }"
                  >{{ job.company.name }}
                </router-link>
                <router-link
                  v-if="job.location && !job.isRemote"
                  :to="{
                    path: '/jobs',
                    query: { location: job.location.address }
                  }"
                  >{{ job.location.shortName }}</router-link
                >
                <router-link
                  v-else-if="job.isRemote"
                  :to="{
                    path: '/jobs',
                    query: { countryCode: 'REMOTE' }
                  }"
                >
                  Remote
                </router-link>
                <router-link
                  v-else-if="job.location"
                  :to="{
                    path: '/jobs',
                    query: { location: job.location.address }
                  }"
                  >{{ job.location.shortName }}</router-link
                >
                <a v-else></a>
                <!-- <a v-else-if="!job.scraped"></a> -->
                <!-- <router-link
                  v-else
                  :to="{
                    path: '/jobs',
                    query: { countryCode: 'REMOTE' }
                  }"
                >
                  Remote
                </router-link> -->
                <router-link
                  v-for="type in job.jobPositionTypes"
                  :key="type"
                  :to="{ path: '/jobs', query: { positionTypes: type } }"
                  >{{ jobPositionTypeLabelById(type) }}</router-link
                >
              </template>
              <template v-else>
                <span v-if="job.company.name">{{ job.company.name }}</span>
                <span v-if="job.location && !job.isRemote">{{ job.location.shortName }}</span>
                <span v-else>Remote</span>
                <span v-for="type in job.jobPositionTypes" :key="type">{{
                  jobPositionTypeLabelById(type)
                }}</span>
              </template>
            </BulletInlineList>
          </div>
        </MediaItem>
        <div class="text-right py-16 fs13 text-gray-600 border-bottom"></div>
        <b-row align-v="center" class="compensation border-bottom mt-16 pb-16">
          <b-col v-if="salaryText" md="auto" class="value">
            Salary
            <span>{{ salaryText }}</span>
          </b-col>
          <b-col v-if="equityText" md="auto" class="value">
            Equity
            <span>{{ equityText }}</span>
          </b-col>

          <b-col col></b-col>

          <b-col v-if="!isCareersPage" md="auto" class="pt-20 pt-md-0">
            <JobsSave :job="job" type="detail" @toggle="toggleSave" />
          </b-col>
        </b-row>
      </header>
    </Container>
    <Container width="medium" spacing="medium">
      <div
        class="view-job-details__body"
        style="max-width: 100%; word-break: normal; overflow-wrap: break-word;"
      >
        <TextBlock class="mt-0">
          <span v-html="job.description"></span>
        </TextBlock>
        <TextBlock v-if="job.email || job.phone">
          <span>
            <strong>For more information or questions please contact us at</strong>
            <span v-if="job.email"
              ><a :href="'mailto:' + job.email">{{ job.email }}</a></span
            >
            <span v-if="job.phone">
              {{ job.email ? 'or' : '' }} phone number
              <a :href="'tel:' + job.phone">{{ job.phone }}</a>
            </span>
          </span>
        </TextBlock>
      </div>

      <TextBlock v-if="job.company.perks.length" class="mb-40">
        <h3 class="fs40 mb-0">Perks and benefits</h3>
        <p class="text-gray-700 pb-30 pb-lg-40">
          This job comes with several perks and benefits
        </p>
        <StartupsBenefits :list="job.company.perks" :max="6" />
      </TextBlock>

      <TextBlock border-top class="view-job-details__company mb-30">
        <b-row>
          <b-col md="7">
            <h3>Working at <br />{{ job.company.name }}</h3>
          </b-col>
          <b-col md="5" class="text-md-right mb-16 mb-md-0">
            <a
              v-if="isCareersPage && !isPreview"
              class="text-blue-900 fw500"
              :href="`//${job.company.externalDomain}`"
              target="_blank"
            >
              <span>See company profile</span><i class="icon-arrow-up-right fs13 pl-10"></i>
            </a>
            <router-link
              v-else
              class="text-blue-900 fw500"
              :to="isPreview ? `${job.company.url}?careerPagePreview=true` : job.company.url"
              target="_blank"
            >
              <span>See company profile</span><i class="icon-arrow-up-right fs13 pl-10"></i>
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="7">
            <div class="view-job-details__company__text">
              <div v-html="job.company.whatWeDo"></div>
            </div>
            <p class="mt-20 mb-40 mb-sm-0">
              <a
                v-if="isCareersPage && !isPreview"
                class="text-blue-900 hidden-md-down"
                :href="`//${job.company.externalDomain}`"
                target="_blank"
              >
                Read more about {{ job.company.name }}
              </a>
              <router-link
                v-else
                class="text-blue-900 hidden-md-down"
                :to="isPreview ? `${job.company.url}?careerPagePreview=true` : job.company.url"
                target="_blank"
                >Read more about {{ job.company.name }}
              </router-link>
            </p>
          </b-col>
          <b-col
            v-if="job.company && job.company.galleryImages && job.company.galleryImages.length"
            md="5"
          >
            <img
              :src="job.company.galleryImages[0].portaitSizeUrl"
              class="view-job-details__company__image"
              alt="company gallery image"
            />
          </b-col>
        </b-row>
      </TextBlock>
    </Container>
    <Container v-if="related && related.length" width="medium" background-color="#F5F7FA">
      <h3 class="fs40 mb-40">Similar jobs</h3>

      <div v-for="item in related" :key="item.id" class="my-10">
        <JobsListItem :job="item" />
      </div>
    </Container>
  </div>
</template>

<script>
import find from 'lodash/find';
import Container from '@/components/Container';
import MediaItem from '@/components/MediaItem';
import BulletInlineList from '@/components/BulletInlineList';
import JobsListItem from '@/components/jobs/JobsListItem';
import TextBlock from '@/components/TextBlock';
import StartupsBenefits from '@/components/startups/StartupsBenefits';
import JobsSave from './JobsSave';
import { salaryOptions, equityOptions } from '@/constants';
import get from 'lodash/get';

export default {
  name: 'JobsPageContent',
  components: {
    Container,
    MediaItem,
    BulletInlineList,
    JobsListItem,
    TextBlock,
    StartupsBenefits,
    JobsSave
  },
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    isCareersPage: {
      type: Boolean,
      default: false
    },
    related: Array
  },
  data() {
    // console.log('this.job', this.job);
    return {
      equityOptions,
      salaryOptions
    };
  },
  computed: {
    country() {
      return this.$store.getters['meta/siteCountryByCode'](this.job.countryCode);
    },
    currency() {
      // if (this.job.isRemote) {
      //   return 'EUR';
      // } else {
      //   return this.country ? this.country.currency : 'EUR';
      // }

      if (this.job.isRemote) {
        return 'EUR';
      } else {
        if (this?.job?.countryCode?.toUpperCase() === 'EU') {
          const parsedCountries = this?.job?.companyCountries
            ? Object.keys(this?.job?.companyCountries)
                .map((key) => ({
                  countryCode: key.toUpperCase(),
                  ...this?.job?.companyCountries[key]
                }))
                .filter((item) => item.status != 'DISABLED')
                .map((item) => this.$store.getters['meta/siteCountryByCode'](item.countryCode)) ||
              []
            : [];

          if (parsedCountries[0] && parsedCountries[0].currency) {
            return parsedCountries[0].currency;
          } else {
            return 'EUR';
          }
        } else {
          return this.country ? this.country.currency : 'EUR';
        }
      }
    },
    salaryText() {
      // console.log('this.job ******************', this.job);
      if (this.job.salary === 'range') {
        if (
          !this.job.salaryRange ||
          (!this.job.salaryRange.min &&
            this.job.salaryRange.min !== '0' &&
            this.job.salaryRange.min !== 0) ||
          !this.job.salaryRange.max
        ) {
          return;
        }
        // if (
        //   !this.job.salaryRange ||
        //   typeof this.job.salaryRange.min !== 'number' ||
        //   !this.job.salaryRange.max
        // ) {
        //   return;
        // }

        return (
          this.toCurrency(Number(this.job.salaryRange.min)) +
          ' - ' +
          this.toCurrency(Number(this.job.salaryRange.max))
        );
      }

      const option = find(salaryOptions, { value: this.job.salary });
      return option && option.text;
    },
    equityText() {
      if (this.job.equity === 'percentage') {
        return this.job.equityPercentage + '%';
      }

      if (this.job.equity === 'undisclosed') {
        return;
      }

      const option = find(equityOptions, { value: this.job.equity });
      return option && option.text;
    },
    isPreview() {
      return get(this.$route, 'query.careerPagePreview', false) ? true : false;
    }
  },
  methods: {
    jobPositionTypeLabelById(id) {
      const type = this.$store.getters['meta/jobPositionTypeById'](id);
      return type && type.label;
    },
    toCurrency(value) {
      return (
        typeof value === 'number' &&
        value.toLocaleString('en-US', {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
      );
    },
    async toggleSave(value) {
      try {
        await this.$store.dispatch('jobs/save', {
          job: this.job,
          value
        });
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss">
.view-job-details {
  @include media-breakpoint-down(sm) {
    .bullet-inline-list {
      margin-top: rem(8px);

      span {
        // display: block;
        margin-bottom: rem(1px);

        &:before {
          display: none;
        }
      }
    }
  }

  @include media-breakpoint-down(xs) {
    .media-item {
      display: block;

      &__image {
        margin: 0 0 rem(20px);
      }
    }
  }

  .company-image {
    max-width: 100%;
  }

  &__title {
    font-size: 2.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  &__company {
    &__text {
      white-space: pre-line;
      padding-right: 2.5rem;
    }

    &__image {
      max-width: 100%;
    }
  }

  header .border-bottom,
  .compensation {
    border-color: $gray-200 !important;
  }

  .compensation {
    .value {
      font-size: rem(15px);
      color: $gray-700;

      &:not(:last-child) {
        margin-right: rem(40px);
      }

      span {
        padding-left: rem(4px);
        color: #000;
        font-weight: 600;
      }
    }
  }
}
</style>
